export const getAuth0LoginFunction = (state: any) => {
  return state?.auth0?.login;
};

export const getAuth0LogoutFunction = (state: any) => {
  return state?.auth0?.logout;
};
